import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const publishedContactsListSlice = createSlice({
    name: 'ui/published-contacts-list',
    initialState: {
        ...initialState,
        filters: { ...initialState.filters, userType: 'all' },
        pureFilters: { ...initialState.pureFilters, userType: 'all' },
        populates: [
            { path: 'country', select: 'name' },
            { path: 'city', select: 'name' }
        ]
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        }
    }
})

export const publishedContactsListActions = publishedContactsListSlice.actions
export default publishedContactsListSlice.reducer
